import React from 'react';
import { useState } from 'react';
import { Button, Modal, notification } from 'antd';
import PropTypes from 'prop-types';
import apiService from '../../axios/apiService';

const UserInvitationDelete = ({ record, onInvitationDelete, onError }) => {
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);
  const handleInviteDelete = () => {
    Modal.confirm({
      title: 'Are you sure you want to delete this invite?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: async () => {
        console.log('record : ', record);
        try {
          setLoading(true);
          // API call to delete the invite
          await apiService.deleteUserInvite(record?.invitationId);
          await api.success({
            message: 'Success',
            description: 'Invite deleted successfully',
            showProgress: false,
          });
          onInvitationDelete?.();
        } catch (error) {
          api.error({
            message: 'Error',
            description: error.message || 'Failed to delete user invite',
            showProgress: false,
          });
          onError?.();
        } finally {
          setLoading(false);
        }
      },
    });
  };

  return record?.associationType === 'inviteUser' && record?.invitationId ? (
    <>
      {contextHolder}
      <Button
        key="ok"
        loading={loading}
        type='primary'
        danger
        onClick={() => handleInviteDelete(record)}
      >
        Delete Invite
      </Button>
    </>
  ) : null;
};

UserInvitationDelete.propTypes = {
  record: PropTypes.any,
  onInvitationDelete: PropTypes.func,
  onError: PropTypes.func,
};

export default UserInvitationDelete;
